import store from '@/store';

const setCurrentToast = (context, toastObj) => new Promise(((resolve, reject) => {
  context.commit('SET_CURRENT_TOAST', toastObj);
}));

const setGlobalToastVisiblity = (context, val) => new Promise(((resolve, reject) => {
  context.commit('SET_GLOBAL_TOAST_VISIBILITY', val);
}));


export default {
  setCurrentToast,
  setGlobalToastVisiblity
};



// WEBPACK FOOTER //
// ./src/store/modules/toasts/actions.js